<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<el-row type="flex">
				<img src="@/assets/img/tag.png" alt="" />
				<span class="title_a">人员基本信息</span>
			</el-row>
			<!-- 表格 -->
			<el-form ref="form" :model="form" label-width="auto" :rules="rules" class="form">
				<!-- 一 -->
				<el-row type="flex" justify="start" class="pesky">
					<el-col class="pesky_left" :xs="12" :sm="12" :md="12" :lg="16" :xl="16">
						<!-- 左一 -->
						<el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="人员姓名：" prop="cyry_xm">
									<el-input v-model="form.cyry_xm" size="large"></el-input>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="联系电话：" prop="cyry_lxdh">
									<el-input v-model="form.cyry_lxdh" size="large"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 左2 -->
						<!-- <el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="血型：" prop="xx">
									<el-select v-model="form.cyry_xx" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in xxList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }"
								class="shengao">
								<el-form-item label="身高：" prop="cyry_sg">
									<el-input v-model.number="form.cyry_sg" size="large">
										<i slot="suffix" class="zzdw">cm</i>
									</el-input>
								</el-form-item>
							</el-col>
						</el-row> -->
						<!-- 左3 -->
						<el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="性别：" prop="cyry_xb">
									<el-select v-model="form.cyry_xb" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in xbList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="婚姻状况：" prop="cyry_hyzk">
									<el-select v-model="form.cyry_hyzk" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in hyzkList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 左4 -->
						<el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="国籍：" prop="cyry_gj">
									<el-select v-model="form.cyry_gj" filterable placeholder="请选择" style="width: 100%">
										<el-option v-for="item in gjList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="民族：" prop="cyry_mzbm">
									<el-select v-model="form.cyry_mzbm" filterable placeholder="请选择" style="width: 100%"
										:disabled="guojiDisabled">
										<el-option v-for="item in mzList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 左5 -->
						<el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="户籍地址：" prop="huji1" ref="huji1">
									<el-cascader v-model="form.huji1" :options="dizhiList" @change="hujiChange" :props="{
										value: 'name',
										label: 'name',
									}" style="width: 100%" placeholder="请选择" clearable filterable :disabled="guojiDisabled || hjdiDisabled">
									</el-cascader>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 11 }" :xl="{ span: 12 }" class="special">
								<el-form-item prop="huji2">
									<!-- @change="hujichange" -->
									<el-input v-model="form.huji2" size="large"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 左6 -->
						<el-row>
							<el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="现住址：" prop="xianzaizhi1">
									<el-cascader v-model="form.xianzaizhi1" :options="dizhiList" @change="xianzaizhiChange" :props="{
										value: 'name',
										label: 'name',
									}" style="width: 100%" placeholder="请选择" clearable filterable></el-cascader>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="23" :md="23" :lg="{ span: 11 }" :xl="{ span: 12 }" class="special">
								<el-form-item prop="xianzaizhi2">
									<el-input v-model="form.xianzaizhi2" size="large"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 左7 -->
						<el-row>
							<!-- <el-col :xs="24" :sm="23" :md="23" :lg="10" :xl="10">
								<el-form-item label="紧急联系人电话：" prop="cyry_jjlxrdh" label-width="135px">
									<el-input v-model="form.cyry_jjlxrdh" size="large"></el-input>
								</el-form-item>
							</el-col> -->
							<!-- <el-col v-if="!optionsData.cyry_jobcard" :xs="24" :sm="23" :md="23" :lg="{ span: 10, offset: 1 }"
								:xl="{ span: 10, offset: 2 }">
								<el-form-item label="考勤编号：" prop="cyry_jobcard">
									<el-input v-model="form.cyry_jobcard" size="large"></el-input>
								</el-form-item>
							</el-col> -->
						</el-row>
					</el-col>
					<el-col class="pesky_right">
						<el-col class="photo_box" :span="24">
							<!-- 右一 -->
							<el-row class="photo_row">
								<el-form-item label="照片上传：" prop="cyry_xp" label-width="110px">
									<el-upload class="avatar-uploader" action="#" :http-request="handleHttpRequest" :show-file-list="false">
										<img v-if="form.cyry_xp" :src="form.cyry_xp" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-row>
							<!-- 右二 -->
							<el-row>
								<el-form-item label="证件类型：" prop="cyry_cyzjdm" label-width="110px">
									<el-select v-model="form.cyry_cyzjdm" filterable placeholder="请选择" style="width: 100%">
										<el-option v-for="item in zjlxList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-row>
							<!-- 右三 -->
							<el-row>
								<el-form-item label="证件号码：" prop="cyry_zjhm" label-width="110px">
									<el-input v-model="form.cyry_zjhm" size="large"></el-input>
								</el-form-item>
							</el-row>
							<!-- 右四 -->
							<!-- <el-row>
								<el-form-item label="出生日期：" prop="cyry_csrq" label-width="110px">
									<el-date-picker v-model="form.cyry_csrq" type="date" placeholder="选择日期" style="width: 100%"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item>
							</el-row> -->
							<!-- 右五 -->
							<!-- <el-row>
								<el-form-item label="紧急联系人：" prop="cyry_jjlxr" label-width="110px">
									<el-input v-model="form.cyry_jjlxr" size="large" style="width: 100%"></el-input>
								</el-form-item>
							</el-row> -->
						</el-col>
					</el-col>
				</el-row>
				<el-row>
					<el-row type="flex">
						<img src="@/assets/img/tag.png" alt="" />
						<span class="title_a">人员其他信息</span>
					</el-row>
				</el-row>
				<el-row type="flex" justify="start" class="pesky">
					<el-col class="pesky_left" :xs="12" :sm="12" :md="12" :lg="16" :xl="16">
						<!-- 左一 -->
						<el-row>
							<el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								<el-form-item label="人员类别：" prop="cyry_rylbdm">
									<el-select v-model="form.cyry_rylbdm" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in rylbList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="人员状态：" prop="cyry_cyztdm">
									<el-select v-model="form.cyry_cyztdm" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in ryztList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 左二 -->
						<el-row>
							<!-- <el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								
								<el-form-item label="职业类别：" prop="cyry_zylbdm" label-width="100px">
									<el-select v-model="form.cyry_zylbdm" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in zylbList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							

								
							</el-col> -->
							<!-- <el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								<el-form-item label="岗位名称：" prop="ylth_gwmc">
									<el-input v-model="form.ylth_gwmc" size="large"></el-input>
								</el-form-item>
							</el-col>  -->
							<!-- <el-col :xs="24" :sm="20" :md="18" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="岗位编号：" prop="cyry_gwbh" label-width="100px">
									<el-input v-model="form.cyry_gwbh" size="large" class="end"></el-input>
								</el-form-item>
							</el-col> -->
							<!-- <el-col :xs="24" :sm="20" :md="18" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="岗位职责：" prop="cyry_gwms">
									<el-input v-model="form.cyry_gwms" size="large"></el-input>
								</el-form-item>
							</el-col> -->
						</el-row>
						<!-- 左三 -->
						<el-row>
							<!-- <el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								<el-form-item label="入职日期：" prop="cyry_rzrq">
									<el-date-picker v-model="form.cyry_rzrq" type="date" placeholder="选择日期" style="width: 100%"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item>

							</el-col> -->
							<el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								<el-form-item label="离职日期：">
									<el-date-picker v-model="form.cyry_lzrq" type="date" placeholder="选择日期" style="width: 100%"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :xs="24" :sm="20" :md="18" :lg="{ span: 10, offset: 1 }" :xl="{ span: 10, offset: 2 }">
								<el-form-item label="备注：" prop="cyry_bz" label-width="100px">
									<el-input v-model="form.cyry_bz" size="large"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :xs="24" :sm="20" :md="18" :lg="10" :xl="10">
								<!-- <el-form-item label="备注：" prop="cyry_bz" label-width="100px">
									<el-input v-model="form.cyry_bz" size="large"></el-input>
								</el-form-item> -->
								<!-- <el-form-item label="入职日期：" prop="cyry_rzrq">
									<el-date-picker v-model="form.cyry_rzrq" type="date" placeholder="选择日期" style="width: 100%"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item> -->

							</el-col>
							
						</el-row>
					</el-col>
					<el-col class="pesky_right">
						<el-col class="photo_box" :xs="12" :sm="12" :md="12" :lg="{ span: 7, offset: 1 }"
							:xl="{ span: 6, offset: 2 }">
							<!-- <el-row>
								<el-form-item label="状态描述：" prop="cyry_zt" label-width="100px">
									<el-input v-model="form.cyry_zt" size="large" class="end" :disabled="form.cyry_cyztdm != 90"></el-input>
								</el-form-item>
							</el-row> -->
							<!-- <el-row>
								<el-form-item label="职业类别：" prop="cyry_zylbdm" label-width="100px">
									<el-select v-model="form.cyry_zylbdm" placeholder="请选择" style="width: 100%">
										<el-option v-for="item in zylbList" :key="item.code" :label="item.title" :value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
							</el-row> -->
							<!-- <el-row>
								<el-form-item label="岗位职责：" prop="cyry_gwms">
									<el-input v-model="form.cyry_gwms" size="large"></el-input>
								</el-form-item>
							</el-row> -->
							<el-row>						
								<el-form-item label="入职日期：" prop="cyry_rzrq">
									<el-date-picker v-model="form.cyry_rzrq" type="date" placeholder="选择日期" style="width: 100%"
										value-format="timestamp">
									</el-date-picker>
								</el-form-item>
							</el-row>
							
							<!-- <el-row>
								<el-form-item label="岗位编号：" prop="cyry_gwbh" label-width="100px">
									<el-input v-model="form.cyry_gwbh" size="large" class="end"></el-input>
								</el-form-item>
							</el-row> -->
							<!-- <el-row>
								<el-form-item label="备注：" prop="cyry_bz" label-width="100px">
									<el-input v-model="form.cyry_bz" size="large"></el-input>
								</el-form-item>

							</el-row> -->

						</el-col>
					</el-col>
				</el-row>
				<div style="text-align: center; margin-top: 51px">
					<el-button type="info" @click="$router.back(-1)">返回</el-button>
					<el-button class="change" type="primary" @click="isOk">确定</el-button>
				</div>
			</el-form>
		</el-card>
	</div>
</template>

<script>
/* eslint-disable */

import * as user from "@/api/user";
import { lists } from "@/utils/dictionary.js";
import dizhi from "@/utils/dizhi";
import { regular } from "@/utils/validate";
export default {
	name: "addEmployeesVue",
	data() {
		return {
			firstPlace: "",
			breadcrumbList: [
				// 面包屑所需数据
				{ name: "从业人员", path: "employees" },
				{ name: "新增", path: "employees/add_employees" },
			],
			optionsData: {},
			form: {
				//表单
				imageUrl: "",
				huji: "", //户籍总
				huji1: [],
				huji2: "",
				xianzaizhi: "", //现住址总
				xianzaizhi1: [],
				xianzaizhi2: "",
				cyry_jobcard: "",//考勤编号
				// 人员状态描述
				cyry_zt: ""
			},
			headers: { "Content-Type": "multipart/form-data" },
			xxList: [],
			xbList: [],
			mzList: [],
			hyzkList: [],
			gjList: [],
			zjlxList: [],
			dizhiList: [],
			rylbList: [],
			zylbList: [],
			rules: {
				//验证规则
				rybh: [{ required: true, message: "请输入人员编码", trigger: "change" }],
				csbm: [{ required: true, message: "请输入场所编码", trigger: "change" }],
				cyry_xp: [{ required: true, message: "请上传照片", trigger: 'change' }],
				cyry_xm: [{ required: true, message: "请输入人员姓名", trigger: "change" }],
				cyry_lxdh: [
					{ required: true, message: "请输入联系电话", trigger: "change" },
					{
						pattern: regular.phone,
						message: "请输入正确的手机号码",
						trigger: "change",
					},
				],
				cyry_xb: [{ required: true, message: "请选择性别", trigger: "change" }],
				cyry_mzbm: [{ required: true, message: "请选择民族", trigger: "change" }],
				cyry_csrq: [{ required: true, message: "请选择出生日期", trigger: "change" }],
				cyry_gj: [{ required: true, message: "请选择国籍", trigger: "change" }],
				cyry_cyzjdm: [{ required: true, message: "请选择证件类型", trigger: "change" }],
				cyry_zjhm: [
					{ required: true, message: "请输入证件号码", trigger: "change" },
					{
						validator: regular.IDCard,
						message: " 请输入正确的证件号码",
						trigger: "change",
					},
				],
				huji1: [{ required: true, message: "请选择省市区", trigger: "change" }],
				huji2: [{ required: true, message: "请完善户籍地址", trigger: "change" }],
				xianzaizhi1: [{ required: true, message: "请选择省市区", trigger: "change" }],
				xianzaizhi2: [{ required: true, message: "请完善现住址", trigger: "change" }],
				cyry_rylbdm: [{ required: true, message: "请选择人员类别", trigger: "change" }],
				cyry_cyztdm: [{ required: true, message: "请选择人员状态", trigger: "change" }],
				cyry_zt:[],

				// cyry_zt:[{ required: true, message: "请输入人员状态描述", trigger: "blur" }],
				cyry_zylbdm: [{ required: true, message: "请选择职业类别", trigger: "change" }],
				cyry_rzrq: [{ required: true, message: "请选择登记日期", trigger: "change" }],
				// cyry_gwbh: [{ required: true, message: "请输入岗位编号", trigger: "change" }],
				// ylth_gwmc: [{ required: true, message: "请输入岗位名称", trigger: "change" }],
				// cyry_gwms: [{ required: true, message: "请输入岗位职责", trigger: "change" }],
				huji: [],
				cyry_jjlxr: [{ required: true, message: "请输入紧急联系人", trigger: "change" }],
				cyry_jjlxrdh: [
					{ required: true, message: "请输入紧急联系人电话", trigger: "change" },
					{
						pattern: regular.phone,
						message: "请输入正确的手机号码",
						trigger: "change",
					},
				],
			},
			guojiDisabled: false,
			reviseId: null,
			hjdiDisabled: false,
			isOkAtate: 0,
			cache: 0 // 0返回 1确认
		}
	},
	created() {
		this.reviseId = this.$route.query.id;
		//获取字典下拉列表
		this.getSelectList();
	},
	mounted() {
		user.getrylb().then(res=>{
			this.rylbList = res
		})
				
		this.info();
	},
	watch: {
		"form.cyry_cyzjdm"(val) {
			/**
			 * 11 身份证校验
			 * 非11 证件号码校验改为'限制字数'
			 */
			var reg = this.form.cyry_zjhm.indexOf("*") !== -1;
			if (val === "11" && !reg) {
				this.rules.cyry_zjhm = [
					{ required: true, message: "请输入证件号码", trigger: "change" },
					{
						validator: regular.IDCard,
						message: " 请输入正确的证件号码",
						trigger: "change",
					},
				];
			} else {
				this.rules.cyry_zjhm = [
					{ required: true, message: "请输入证件号码", trigger: "change" },
					{
						min: 0,
						max: 32,
						message: "长度在 0 到 32 个字符",
						trigger: "change",
					},
				];
			}
		},
		"form.cyry_gj"(val) {
			/**
			 * 国籍非中国
			 * 1: 民族校验取消
			 * 2: 户籍和现住址选择框校验取消
			 * 3: 民族和户籍1 清空
			 */

			if (val !== "CHN") {
				this.rules.cyry_mzbm = [];
				this.rules.huji1 = [];
				this.guojiDisabled = true;
				this.form.cyry_mzbm = "";
				this.form.huji1 = "";
			} else {
				this.rules.cyry_mzbm = [
					{ required: true, message: "请选择民族", trigger: "change" },
				];
				this.rules.huji1 = [{ required: true, message: "请选择省市区", trigger: "change" }];
				this.guojiDisabled = false;
			}
		},
		"form.cyry_cyztdm"(val) {
		
			if (val != 90) {
				this.rules.cyry_zt = [];
				
				this.form.cyry_zt = "";
			} else {
				this.rules.cyry_zt = [
					{ required: true, message: "请输入人员状态描述", trigger: "blur" },
				];
			}
		},
		hjdiDisabled(val) {
			if (!val) {
				this.rules.huji1 = [{ required: true, message: "请选择省市区", trigger: "change" }];
			} else {
				this.rules.huji1 = [];
			}
		},
		isOkAtate(val) {
			if (val == 1) {
				this.$refs.huji1.clearValidate()
				setTimeout(() => {
					this.isOk()
				}, 20)
			}
		},
		cache(val) {
			// 点击确认,清除缓存
			if (val === 1) {
				this.$store.commit("setKeep", "");
			}
		},
		'$store.state.user.isAddE'(newVal, oldVal) {
			//对数据执行操作
			console.log(newVal, oldVal)
			if (newVal) {
				this.setData()
				this.hjdiDisabled = true
			}
		}
	},
	methods: {
		async setData() {
			// 读卡信息
			let empData = sessionStorage.getItem('addEmpData') ? JSON.parse(sessionStorage.getItem('addEmpData')) : []
			console.log(empData);
			// this.$nextTick(()=>{
			//时间戳处理
			let date = empData[4].slice(0, 4) + '-' + empData[4].slice(4, 6) + '-' + empData[4].slice(6, 8) + ' 00:00:00'
			// 获取地址最外层
			this.getAddress(this.dizhiList, empData[5].slice(0, 3), "")
			//获取卡类型
			let zjlxCode = this.zjlxList.filter(i => i.title == empData[0])[0].code
			//户籍地址
			let hujiData = ''
			if (empData[5].slice(0, 3).indexOf('省') > 0) {
				hujiData = empData[5].slice(0, 3) + ' ' + empData[5].slice(3, 6) + ' ' + empData[5].slice(6, 9)
			} else {
				hujiData = this.firstPlace + ' ' + empData[5].slice(0, 3) + ' ' + empData[5].slice(3, 6)
			}
			hujiData = hujiData.split(' ')

			// 民族类型
			let mzbmCode = this.mzList.filter(i => i.title.indexOf(empData[3]) > -1)
			if (mzbmCode.length > 0) {
				this.$set(this.form, 'cyry_mzbm', mzbmCode[0].code)
				// this.form.cyry_mzbm = mzbmCode[0].code
				//国籍
				this.$set(this.form, 'cyry_gj', 'CHN')
				// this.form.cyry_gj = 'CHN'

			}
			//性别
			let nex = this.xbList.filter(i => i.title == empData[2])[0]


			await this.$set(this.form, 'cyry_cyzjdm', zjlxCode)
			await this.$set(this.form, 'cyry_zjhm', empData[6])
			await this.$set(this.form, 'cyry_xm', empData[1])
			await this.$set(this.form, 'cyry_xb', nex.code)
			await this.$set(this.form, 'cyry_csrq', Number(new Date(date)))
			await this.$set(this.form, 'huji2', empData[5])
			// 身份证图片
			await this.$set(this.form, 'cyry_xp', 'data:image/jpeg;base64,' + empData[17])
			await this.$set(this.form, 'huji1', [])
			//信息填充完毕，缓存清空


			this.$store.dispatch('user/changeAddEState', false)
			sessionStorage.removeItem('addEmpData')

			// })


		},
		dataURLtoBlob(dataurl) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = window.atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n);
			console.log(arr);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			});
		},
		getAddress(data, sameName, pName) {
			data.map(i => {
				if (i.name == sameName) {
					this.firstPlace = pName == "" ? i.name : pName
				} else {
					if (i.children) {
						this.getAddress(i.children, sameName, i.name)
					}
				}
			})
		},
		async info() {
			const id = this.reviseId;
			// 如果路由传参 id , 那么是编辑页面 , 无 则是新增页面
			if (id) {
				// 修改
				this.breadcrumbList[1].name = '修改'
				// 回填
				const res = await user.getEmployees_details(id)
				this.optionsData = JSON.parse(JSON.stringify(res))
				this.form = res
				// 回填处理
				this.dealData(res)
			} else {
				// 新增
				this.$set(this.form, "cyry_gj", "CHN");
				this.$set(this.form, "cyry_xp", "")
				this.breadcrumbList[1].name = "新增";
			}
		},
		dealData(res) { //数据回填
			// 地址
			this.form.huji = res.cyry_hjdz;
			this.form.xianzaizhi = res.cyry_zzdz;
			this.form.cyry_jobcard = res.cyry_jobcard;
			let hujiList = res.cyry_hjdz.split("-");
			let xianzaizhiList = res.cyry_zzdz.split("-");
			const hujiList1 = hujiList.length > 2 ? [hujiList[0], hujiList[1], hujiList[2]] : []
			this.$set(this.form, "huji1", hujiList1);
			this.$set(this.form, "huji2", hujiList[hujiList.length - 1]);
			this.$set(this.form, "xianzaizhi1", [
				xianzaizhiList[0],
				xianzaizhiList[1],
				xianzaizhiList[2],
			]);
			this.$set(this.form, "xianzaizhi2", xianzaizhiList[xianzaizhiList.length - 1]);
			this.$set(this.form, "cyry_zylbdm", res.cyry_zylbdm)
			// 时间
			this.form.cyry_csrq = res.cyry_csrq ? res.cyry_csrq * 1000 : "";
			this.form.cyry_lzrq = res.cyry_lzrq ? res.cyry_lzrq * 1000 : "";
			this.form.cyry_rzrq = res.cyry_rzrq ? res.cyry_rzrq * 1000 : "";
		},
		getSelectList() {	//获取字典
			this.xxList = lists["XX"];
			this.xbList = lists["XB"];
			this.mzList = lists["NATION"];
			this.hyzkList = lists["HYZK"];
			this.gjList = lists["COUNTRY"];
			this.zjlxList = lists["0203"];
			this.dizhiList = dizhi;
			// this.rylbList = lists["RYLB"];
			this.ryztList = lists["RYZT"];
			this.zylbList = lists["ZYLB"];
		},
		async handleHttpRequest(e) {	//上传图片
			const isJPG =
				e.file.type == "image/jpeg" ||
				e.file.type == "image/png" ||
				e.file.type == "image/gif";
			const isLt1M = e.file.size / 1024 / 1024 < 1;
			if (!isJPG) {
				this.$message.warning("上传头像图片只能是 JPG/PNG/GIF 格式!");
				return;
			}
			if (!isLt1M) {
				this.$message.warning("上传头像图片大小不能超过 1MB!");
				return;
			}
			console.log(isLt1M)
			let formData = new FormData()
			formData.append('image', e.file)
			console.log('e.file', e.file);
			const res = await user.uploadImg(formData)
			this.$set(this.form, 'cyry_xp', res.showimg)
		},
		hujiChange(val) {	//户籍地址
			if (!val && val != 0) return;
			let data = val;
			this.form.huji = data.join("-");
		},

		xianzaizhiChange(val) {	//现住址
			if (!val && val != 0) return;
			let data = val;
			this.form.xianzaizhi = data.join("-");
		},

		isOk() {// 确定
			this.cache = 1;
			if (this.reviseId && this.form.huji1.length == 0 && this.isOkAtate == 0) {
				this.hjdiDisabled = true
				this.isOkAtate = 1
				return
			}
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					const data2 = this.form.xianzaizhi1.join("-");
					if (this.form.cyry_gj === "CHN") {
						//如果不是中国国籍,则民族和huji1不可选
						const data1 = this.form.huji1.join("-");
						console.log(this.form.huji1);
						this.form.huji = `${data1}-${this.form.huji2}`;
						this.form.xianzaizhi = `${data2}-${this.form.xianzaizhi2}`;

					} else {
						this.form.huji = this.form.huji2;
						this.form.xianzaizhi = `${data2}-${this.form.xianzaizhi2}`;
					}
					if (this.reviseId) {
						//修改

						await user.saveEmployeeItem({
							id: this.reviseId,
							cyry_xm: this.form.cyry_xm,
							cyry_lxdh: this.form.cyry_lxdh,
							// cyry_xx: this.form.cyry_xx,
							// cyry_sg: this.form.cyry_sg,
							cyry_xb: this.form.cyry_xb,
							cyry_mzbm: this.form.cyry_mzbm,
							cyry_gj: this.form.cyry_gj,
							cyry_cyzjdm: this.form.cyry_cyzjdm,
							// cyry_jobcard: this.form.cyry_jobcard,

							cyry_hjdz: this.form.huji,
							cyry_zzdz: this.form.xianzaizhi,

							cyry_xp: this.form.cyry_xp,

							cyry_hyzk: this.form.cyry_hyzk,
							cyry_zjhm: this.form.cyry_zjhm,
							// cyry_csrq: this.form.cyry_csrq ? this.form.cyry_csrq / 1000 : "",
							// cyry_jjlxr: this.form.cyry_jjlxr,
							// cyry_jjlxrdh: this.form.cyry_jjlxrdh,

							// cyry_zylbdm: this.form.cyry_zylbdm,
							cyry_rylbdm: this.form.cyry_rylbdm,
							cyry_cyztdm: this.form.cyry_cyztdm,
							// cyry_zt: this.form.cyry_zt,
							// ylth_gwmc: this.form.ylth_gwmc,
							// cyry_gwms: this.form.cyry_gwms,
							cyry_lzrq: this.form.cyry_lzrq ? this.form.cyry_lzrq / 1000 : null,
							cyry_rzrq: this.form.cyry_rzrq ? this.form.cyry_rzrq / 1000 : "",
							// cyry_gwbh: this.form.cyry_gwbh,
							cyry_bz: this.form.cyry_bz,
						});
						this.$message.success("修改成功!");
					} else {
						//新增
						await user.addEmployees({
							id: this.reviseId,
							cyry_xm: this.form.cyry_xm,
							cyry_lxdh: this.form.cyry_lxdh,
							// cyry_xx: this.form.cyry_xx,
							// cyry_sg: this.form.cyry_sg,
							cyry_xb: this.form.cyry_xb,
							cyry_mzbm: this.form.cyry_mzbm,
							cyry_gj: this.form.cyry_gj,
							cyry_cyzjdm: this.form.cyry_cyzjdm,
							// cyry_jobcard: this.form.cyry_jobcard,

							cyry_hjdz: this.form.huji,
							cyry_zzdz: this.form.xianzaizhi,

							cyry_xp: this.form.cyry_xp,

							cyry_hyzk: this.form.cyry_hyzk,
							cyry_zjhm: this.form.cyry_zjhm,
							// cyry_csrq: this.form.cyry_csrq ? this.form.cyry_csrq / 1000 : "",
							// cyry_jjlxr: this.form.cyry_jjlxr,
							// cyry_jjlxrdh: this.form.cyry_jjlxrdh,

							// cyry_zylbdm: this.form.cyry_zylbdm,
							cyry_rylbdm: this.form.cyry_rylbdm,
							cyry_cyztdm: this.form.cyry_cyztdm,
							// cyry_zt: this.form.cyry_zt,
							// ylth_gwmc: this.form.ylth_gwmc,
							// cyry_gwms: this.form.cyry_gwms,
							cyry_lzrq: this.form.cyry_lzrq ? this.form.cyry_lzrq / 1000 : "",
							cyry_rzrq: this.form.cyry_rzrq ? this.form.cyry_rzrq / 1000 : "",
							// cyry_gwbh: this.form.cyry_gwbh,
							cyry_bz: this.form.cyry_bz,
						});
						this.$message.success("新增成功!");
					}
					this.$router.push("/employees")
				} else {
					console.log("error submit!!")
					return false;
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.main {
	margin: 20px;
	padding: 20px 20px;

	.title_a {
		margin-left: 5px;
		font-size: 18px;
		font-family: Source Han Sans SC;
		font-weight: bold;
		color: #6345d5;
		line-height: 36px;
	}

	/deep/ .form {
		.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.avatar-uploader .el-upload:hover {
			border-color: #409eff;
		}

		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 100%;
			height: 100%;
			// line-height: 178px;
			text-align: center;
		}

		.avatar {
			width: 100%;
			height: 100%;
			display: block;
		}
	}

	.pesky_left {
		margin-top: 20px;

		.special {
			/deep/ .el-form-item__content {
				margin-left: 50px !important;
			}
		}
	}

	/deep/ .el-input--large,
	/deep/ .el-input,
	/deep/ .el-input__inner {
		height: 50px;
	}

	.pesky_right {
		flex: 1;
		padding-top: 22px;

		/deep/ .el-row {
			width: 100%;
		}
	}

	/deep/ .el-input__suffix {
		text-align: center;
	}

	.zzdw {
		margin-right: 12px;
		font-size: 12px;
		color: #6345d5;
		font-style: normal;
	}

	.photo_box {
		position: relative;
		height: 100%;
		width: 90%;

		.photo_row {
			/deep/ .el-form-item__label {
				position: absolute;
				top: 50%;
				transform: translate(0, -50%);
			}

			/deep/ .avatar-uploader,
			/deep/ .el-upload,
			/deep/.el-upload--text,
			/deep/ .el-icon-plus,
			/deep/.avatar-uploader-icon {
				width: 100%;
				height: 100%;
			}

			/deep/ .avatar-uploader-icon {
				line-height: 120px;
			}

			/deep/ .el-form-item__content {
				width: 120px;
				height: 120px;
			}
		}
	}

	.shengao {
		/deep/ .el-form-item__content {
			line-height: 50px;
		}
	}
}
</style>
